import React from "react"
import {simplemd} from '../functions/simplemd'

export default function Text(props) {
    const html = (props.content) ? simplemd(props.content) : ''
    return (<p className={props.className} dangerouslySetInnerHTML={{__html: html}}/>)
}